/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Save_SuccessInputs */

const vi_grower_camera_settings_save_success = /** @type {(inputs: Grower_Camera_Settings_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu cấu hình camera hộ trồng`)
};

/**

* @param {Grower_Camera_Settings_Save_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_save_success = /** @type {((inputs?: Grower_Camera_Settings_Save_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Save_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_save_success(inputs)
});